module.exports = __webpack_public_path__ + "static/media/people_in_office.0436f9e7.png";